export default {
  fetching: true,
  loading: true,

  appList: [],
  permissionList: [],
  totalRecords: 0,
  pageSize: 0,
  currentPage: 0,

  isSucceeded: null,
  resultMessage: "",
  erroCode: 0,
  errorMessage: "",
  validationErrors: [],
};
